module.exports = __webpack_public_path__ + "img/icon_赛事等级徽章_B级@3x.569faff5.png";